import { useDevice } from "@hooks/useDevice";
import Box from "@memorang/ui/components/Box";
import Container from "@memorang/ui/components/Container";
import Loader from "@memorang/ui/components/Loader";
import { NestedExamChipsContainer } from "./NestedExamChipsContainer";

const ProgressLoadingContainer = () => {
	const { isMobile } = useDevice();

	return (
		<Container>
			<NestedExamChipsContainer
				disabled
				containerStyle={{
					paddingTop: 32,
					paddingBottom: 16,
					paddingHorizontal: isMobile ? 0 : 16,
				}}
			/>
			<Box flex={1} justifyContent="center" alignItems="center" height="100%">
				<Loader />
			</Box>
		</Container>
	);
};

export default ProgressLoadingContainer;
